<template>
  <div class="section">
    <div class="container is-fluid">
          <br>
        <h1 class="title is-2 is-size-3-touch has-text-centered is-700 has-text-white">
          <i class="fas fa-book"></i>
        </h1>
        <h1 class="title is-2 is-size-3-touch has-text-centered is-700 has-text-white">
          Manual de implementación
        </h1>
        <h1 class="subtitle is-3 is-size-4-touch has-text-centered is-300 has-text-white">
          por proyecto ganador de la Incubadora 2020
        </h1>
          <br>
      <br>

      <div class="columns is-multiline is-centered is-mobile">
        <div class="column is-2-widescreen is-4-desktop is-4-tablet is-6-mobile">
          <a href="/pdf/manual_ferramentas_de_esquina.pdf" target="_blank"><img src="/img/manual_ferramentas_de_esquina.png" class="image" /></a>
            <a href="/pdf/manual_ferramentas_de_esquina.pdf" target="_blank" class="button is-primary is-fullwidth is-radiusless"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
          
          <div class="subtitle is-6 has-text-white my-3">
            Brasil
          </div>
          <hr class="my-3">
          <div class="title is-3 is-size-5-touch has-text-white my-3">
            Ferramentas de esquina
          </div>
          <div class="subtitle is-size-7 has-text-white my-3">
            Guilherme Bruno Tiefensee Cascaes, Letícia Maria Anselmo, Sofia Marterer, Vinícius Mariot
          </div>
        </div>
        <div class="column is-2-widescreen is-4-desktop is-4-tablet is-6-mobile">
         <a href="/pdf/manual_parada_sana.pdf" target="_blank"><img src="/img/manual_parada_sana.png" class="image" /></a>
            <a href="/pdf/manual_parada_sana.pdf" target="_blank" class="button is-primary is-fullwidth is-radiusless"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
         
          <div class="subtitle is-6 has-text-white my-3">
            Panamá
          </div>
          <hr class="my-3">
          <div class="title is-3 is-size-5-touch has-text-white my-3">
            La parada sana
          </div>
          <div class="subtitle is-size-7 has-text-white my-3">
            Huertos Urbanos de Panamá, Betty Chemier, Harneet Singh, Evalynn De Ycaza, Luis Mendieta
          </div>
        </div>
        <div class="column is-2-widescreen is-4-desktop is-4-tablet is-6-mobile">
          <a href="/pdf/manual_brincando_com_comfianca.pdf" target="_blank"><img src="/img/manual_brincando_com_comfianca.png" class="image" /></a>
            <a href="/pdf/manual_brincando_com_comfianca.pdf" target="_blank" class="button is-primary is-fullwidth is-radiusless"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
          
          <div class="subtitle is-6 has-text-white my-3">
            Brasil
          </div>
          <hr class="my-3">
          <div class="title is-3 is-size-5-touch has-text-white my-3">
            Brincando com Confiança
          </div>
          <div class="subtitle is-size-7 has-text-white my-3">
            Associação A Cidade Precisa de Você
          </div>
        </div>
        <div class="column is-2-widescreen is-4-desktop is-4-tablet is-6-mobile">
          <a href="/pdf/manual_teatro_aumentado.pdf" target="_blank"><img src="/img/manual_teatro_aumentado.png" class="image" /></a>
            <a href="/pdf/manual_teatro_aumentado.pdf" target="_blank" class="button is-primary is-fullwidth is-radiusless"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
          
          <div class="subtitle is-6 has-text-white my-3">
            Uruguay
          </div>
          <hr class="my-3">
          <div class="title is-3 is-size-5-touch has-text-white my-3">
            Teatro Aumentado
          </div>
          <div class="subtitle is-size-7 has-text-white my-3">
            Federico Lagomarsino, Leonor Courtoisie, Santiago Albano, Joaquina Rivas, Nicolás Arduino, Federico Barroso, Gastón Dufau, Pablo Gómez Oliver
          </div>
        </div>
        <div class="column is-2-widescreen is-4-desktop is-4-tablet is-6-mobile">
          <a href="/pdf/manual_coordenada_0.pdf" target="_blank"><img src="/img/manual_coordenada_0.png" class="image" /></a>
            <a href="/pdf/manual_coordenada_0.pdf" target="_blank" class="button is-primary is-fullwidth is-radiusless"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
          
          <div class="subtitle is-6 has-text-white my-3">
            Ecuador
          </div>
          <hr class="my-3">
          <div class="title is-3 is-size-5-touch has-text-white my-3">
            Coordenada 0
          </div>
          <div class="subtitle is-size-7 has-text-white my-3">
            MINKA-URB, José Aguirre Déleg, Ana Benalcazar Nieves, Gabriela Bustos Cordero, Daniel Tello Enríquez, Lina Flórez Díaz, María Elisa Rodas Correa, Sebastián Vanegas Bravo
          </div>
        </div>
        <div class="column is-2-widescreen is-4-desktop is-4-tablet is-6-mobile">
        <a href="/pdf/manual_anudando_la_red.pdf" target="_blank"><img src="/img/manual_anudando_la_red.png" class="image" /></a>
            <a href="/pdf/manual_anudando_la_red.pdf" target="_blank" class="button is-primary is-fullwidth is-radiusless"><i class="fas fa-download fa-fw"></i>&nbsp;&nbsp;DESCARGAR</a>
        
          <div class="subtitle is-6 has-text-white my-3">
            Chile
          </div>
          <hr class="my-3">
          <div class="title is-3 is-size-5-touch has-text-white my-3">
            Anudando la red
          </div>
          <div class="subtitle is-size-7 has-text-white my-3">
            Valentina González, Paloma Mateo, Victoria De La Barra, Juliana Rocha, Camila Barreau
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      manuales: [
        {}
      ]
    }
  }
}
</script>

<style scoped>
.section{
  background: rgb(110,85,158);
  background: -moz-linear-gradient(0deg, rgba(110,85,158,1) 16%, rgba(86,68,121,1) 67%);
  background: -webkit-linear-gradient(0deg, rgba(110,85,158,1) 16%, rgba(86,68,121,1) 67%);
  background: linear-gradient(0deg, rgba(110,85,158,1) 16%, rgba(86,68,121,1) 67%);
}
</style>



